import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

// Focuses the host element once, right after it's added to the DOM (e.g. an inline-edit input).
@Directive({ selector: '[appAutoFocus]' })
export class AutoFocusDirective implements AfterViewInit {
    private readonly _elementRef = inject(ElementRef<HTMLElement>);

    ngAfterViewInit(): void {
        this._elementRef.nativeElement.focus();
    }
}
